import { render } from "./Loading.vue?vue&type=template&id=bcd1026c"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=bcd1026c&lang=scss"

import exportComponent from "/Users/igorho/Documents/Personal/01 Projects/taxi_effective/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__